import { layout } from 'thewest/App.routing'

export const businessSegment = [
    layout.component({
        type: 'sierra',
        props: {
            verticalSpacing: 'gridGap',
            fixedRatios: ['16:9'],
            heroImageLayout: 'fill-container-horizontally',
            cardOrientation: {
                type: 'Landscape-Portrait',
                maxBreakpoint: 'md',
            },
            cardLayout: [{ type: 'hero', disableImageLazyLoad: false }, 'commonWithBackground'],
            sectionHeader: {
                heading: 'Business',
                headingUrl: '/business',
                section: 'business',
            },

            dataDefinitionArgs: {
                type: 'curation',
                name: 'business',
                offset: 0,
                pageSize: 2,
            },
        },
    }),
    layout.component({
        type: 'lima',
        props: {
            verticalSpacing: 'xl',
            fixedRatios: ['16:9'],
            intermediateColumns: 2,
            finalColumns: 4,
            hideTeaser: false,
            hideByline: false,
            hasBackground: true,
            cardLayout: [
                ['teaserWithBackground'],
                ['teaserWithBackground'],
                ['teaserWithBackground'],
                ['teaserWithBackground'],
            ],
            cardOrientation: { type: 'Landscape-Portrait' },

            dataDefinitionArgs: {
                type: 'curation',
                name: 'business',
                offset: 2,
                pageSize: 4,
            },
        },
    }),
]
